import { Component, input } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe, UpperCasePipe, LowerCasePipe } from '@angular/common';

import { IColumn } from '@app/shared/interfaces/column.interface';
import { DynamicPipe } from '@shared/pipes/dynamic.pipe';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-table-component',
    standalone: true,
    imports: [TableModule, CommonModule, DynamicPipe, ButtonModule],
    providers: [DatePipe, DecimalPipe, UpperCasePipe, LowerCasePipe],
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})
export class TableComponent<T> {
    data = input<T[]>([]);
    cols = input<IColumn[]>([]);
    pagination = input(true);
    loading = input(true);
    rowsPerPage = input(8);
    evenRowColor = input('#FFFFFF');
    oddRowColor = input('#F8FAFC');
    sortMode = input<'single' | 'multiple'>('single');

    currentPage = 1;
    first = 0;

    get totalPages(): number {
        return Math.ceil(this.data().length / this.rowsPerPage());
    }

    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.first = (this.currentPage - 1) * this.rowsPerPage();
        }
    }

    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.first = (this.currentPage - 1) * this.rowsPerPage();
        }
    }
}
